import {Template, Component} from '@scoutgg/ftw/source/lib'
import template from './users.jade'
import notify from '@scoutgg/ftw/source/services/notification'
import {User} from '../../models'
import '../status'
import CreateNewUser from '../create-new-user'
import Modal, {prompt} from '@scoutgg/ftw/source/services/modal'
import moment from 'moment'

@Component('sporty')
@Template(template)
export default class Users extends HTMLElement {
  attached() {
    this.reload()
  }


  filterUsers(e) {
    let val = (e.target.value).toLowerCase()
    if (val === '') {
      this.res = this.users
    } else {
      this.res = Object.keys(this.users)
        .filter(key => ((this.users[key].username.toLowerCase())).includes(val) ||
        ((this.users[key].email.toLowerCase())).includes(val) )
        .reduce((obj, key) => {
          obj.push(this.users[key])
          return obj;
        }, []);
    }
    this.render()
  }

  reload() {
    this.update(User.load({ $reload: true }))
      .then( data => {
        this.res = Object.assign({}, data.users)
        this.render()
      })
  }

  changeRole(user, role) {
    const oldRole = user.role
    user.role = role
    this.render()
    return user
      .save({ role })
      .then(() => {
        notify(`User ${user._id} has had role changed to ${role}.`, {
          level: 'success',
          timeout: 5000,
        })
      })
      .catch(err => {
        notify(err.message, { level: 'danger', timeout: 10000 })
        user.role = oldRole
        this.render()
      })
  }

  remove(user) {
    prompt(`${user.email}`, {
      type: 'custom',
      className: 'remove-receivers',
      title: 'You want to remove User',
      submitBtnName: 'Confirm',
      cancelBtnName: 'Decline',
    }).then(() => {
      user.destroy().then(() => {
        notify(`User ${user._id} has been destroyed.`, {
          level: 'success',
          timeout: 5000,
        })
        this.reload()
      }).catch(() => {
        return this.render()
      })
      this.render()
    })
  }

  createUser() {
    return Modal(
      CreateNewUser(),
      { hideCloseBtn: true },
    )
  }

  abriviature(username) {
    return username.split(' ').map(i => i.charAt(0)).join('')
  }
}
